import { Module } from 'vuex';
import { Floor, Zone } from '@/utils/api';
import { RootState } from '..';
import getFloorByID from '@/utils/helpers/getFloorByID';
import { FloorState } from '@/store/modules/app';

const SET_ACTIVE_ZONE = 'SET_ACTIVE_ZONE';
const SET_ACTIVE_SUBZONE = 'SET_ACTIVE_SUBZONE';
const ADD_COMPLETED_ZONE = 'ADD_COMPLETED_ZONE';
const RESET_STATE = 'RESET_STATE';

export interface GroundFloorState extends FloorState {
  activeZoneID: string;
  activeSubzoneID: string;
  completedZoneIDs: string[];
}

const groundFloorInitialState = (): GroundFloorState => ({
  activeZoneID: '',
  activeSubzoneID: '',
  completedZoneIDs: [],
  floorID: 'GF'
});

export const groundFloorModule: Module<GroundFloorState, RootState> = {
  namespaced: true,
  state: groundFloorInitialState(),
  getters: {
    floor(_state, _getters, rootState): Floor | undefined {
      return getFloorByID(rootState.configuration.houseConfiguration?.floors || [], _state.floorID);
    },
    activeZone(state, getters): Zone {
      return getters.floor?.zones.find((zone: Zone) => zone.ID === state.activeZoneID);
    },
    activeSubzone(state, getters): Zone | undefined {
      return getters.activeZone?.zones?.find((zone: Zone) => zone.ID === state.activeSubzoneID) ?? undefined;
    }
  },
  actions: {
    showLayout({ dispatch }) {
      dispatch('updateActiveZone', '');
    },
    updateActiveZone({ commit, state, getters, dispatch }, zoneID: string) {
      dispatch('addCompletedZone', state.activeZoneID);

      commit(SET_ACTIVE_ZONE, zoneID);
      commit(SET_ACTIVE_SUBZONE, getters.activeZone?.zones ? getters.activeZone.zones[0].ID : '');
    },
    updateActiveSubzone({ commit }, zoneID: string) {
      commit(SET_ACTIVE_SUBZONE, zoneID);
    },
    addCompletedZone({ commit, state }, zoneID: string) {
      if (zoneID && !state.completedZoneIDs.find(completedZoneID => completedZoneID === zoneID)) {
        commit(ADD_COMPLETED_ZONE, zoneID);
      }
    },
    resetState({ commit }) {
      commit(RESET_STATE);
    }
  },
  mutations: {
    [SET_ACTIVE_ZONE](state, zoneID: string) {
      state.activeZoneID = zoneID;
    },
    [SET_ACTIVE_SUBZONE](state, zoneID: string) {
      state.activeSubzoneID = zoneID;
    },
    [ADD_COMPLETED_ZONE](state, zoneID: string) {
      state.completedZoneIDs = [...state.completedZoneIDs, zoneID];
    },
    [RESET_STATE](state) {
      Object.assign(state, groundFloorInitialState());
    }
  }
};
